import React from 'react';
import UnitDivisionFormDialog from './UnitDivisionFormDialog';
import UnitDivisionFormDialogService from '../../services/UnitDivisionFormDialogService';
import { observer } from 'mobx-react';

const UnitDivisionFormDialogContainer = () => (
  <UnitDivisionFormDialog
    onChange={UnitDivisionFormDialogService.form.setValue}
    onDivide={UnitDivisionFormDialogService.handleDivide}
    onCancel={UnitDivisionFormDialogService.handleCancel}
    isOpen={UnitDivisionFormDialogService.isOpen}
    errors={UnitDivisionFormDialogService.form.errors}
    values={UnitDivisionFormDialogService.form.getValues()}
    submitting={UnitDivisionFormDialogService.submit.fetching}
  />
);

export default observer(UnitDivisionFormDialogContainer);
